import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup-template',
  templateUrl: './signup-template.component.html',
})
export class SignupTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
